import { inFormenScope } from './editing';

export function cancellationDay() {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
  const value = type => parts.find(part => part.type === type).value;
  return `${value('year')}-${value('month')}-${value('day')}`;
}

export function canCancelCompletedShipment(record, user, manager, assignment, regions, today = cancellationDay()) {
  if (!user?.uid || record?.durum !== 'GONDERILDI') return false;
  if (manager) return true;
  if (!inFormenScope(record, assignment)) return false;
  const region = regions.find(item => item.id === record.bolgeId);
  if (!region) return false;
  const limit = Number(region.geriyeDonukGun ?? 2);
  return Number.isFinite(limit) && limit >= 0 && [record.dolumTarihi || record.sevkTarihi, record.dokumTarihi || record.dolumTarihi || record.sevkTarihi].every(date => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date || '')) return false;
    const timestamp = Date.parse(`${date}T12:00:00Z`);
    const age = (Date.parse(`${today}T12:00:00Z`) - timestamp) / 86400000;
    return Number.isFinite(timestamp) && new Date(timestamp).toISOString().slice(0, 10) === date && age >= 0 && age <= limit;
  });
}

export const isCancelled = record => record.durum === "IPTAL";
export const isCompletedShipment = record => record.durum !== "DOKUM_BEKLIYOR" && !isCancelled(record);
export function canCancelShipment(record, user, manager, canEnter, inFormenScope = false) {
  const owner = record.createdByUid ? record.createdByUid === user?.uid : record.createdBy === user?.email || record.createdBy === user?.uid;
  return !!user?.uid && (manager || (canEnter && owner) || inFormenScope) && record.durum === "DOKUM_BEKLIYOR" && !record.dokumTarihi && !record.dokumFisiFotografi?.url;
}
